import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import AchievementFormFields from './AchievementFormFields';
import { isProtectedAchievementName } from './achievementConstants';
import ProtectedAchievementNotice from './components/ProtectedAchievementNotice';

const AchievementEditForm = (formProps) => {
  const { record } = formProps;

  if (!record) {
    return null;
  }

  if (isProtectedAchievementName(record.name)) {
    return <ProtectedAchievementNotice record={record} />;
  }

  return (
    <SimpleForm {...formProps}>
      <AchievementFormFields />
    </SimpleForm>
  );
};

const AchievementEdit = (props) => {
  return (
    <Edit {...props}>
      <AchievementEditForm />
    </Edit>
  );
};

export default AchievementEdit;
